import React, { Component } from "react";
import { Radio } from "@rmwc/radio";
import { connect } from "react-redux";
import * as actionCreator from "../../../action/index.js";
class Questions extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="question-wrapper">
        <div>
          {this.props.const_var.estimator_QuestionAnswer != undefined &&
          this.props.const_var.estimator_QuestionAnswer.length > 0 && this.props.isNameofModule == 'quote' ? (
            <h4 className={this.props.const_var?.crmSetting?.main_domain_url == "keensbuildings.com" ? "mt-4 mb-2 col-12 save-title p-0" : "mt-4 mb-3 col-12 save-title p-0"}>Just a few more questions</h4>
          ) : (
            ""
          )}

          {this.props.const_var.estimator_QuestionAnswer != undefined && this.props.const_var.estimator_QuestionAnswer.length > 0 ? 
            Object.entries(this.props.const_var.estimator_QuestionAnswer).map(
              ([key, value]) => {
                if (value.is_question != undefined) {
                  if (
                    value.is_question == "both" ||
                    value.is_question == this.props.isNameofModule
                  ) {
                    return (
                      <div className={this.props.isNameofModule == 'quote' ? "question-item mb-3" : "question-item"}>
                        <div className={this.props.isNameofModule == 'quote' ? "question-name save-quote-ques-name" : "question-name"}>
                          {value.title}
                          {this.props.const_var.crmSetting.is_CRM != undefined && value.is_required == 1 && this.props.const_var.crmSetting.is_CRM == true ? 
                            (
                              <span
                                className="ml-1 "
                                style={{ color: "#ff6161" }}
                              >
                                *
                              </span>
                            ) : null}
                        </div>
                        <div className={this.props.isNameofModule == 'quote' ? "radio-group save-quote-ques-radio" : "radio-group"}>
                          {Object.entries(value.options).map(
                            ([key1, value1]) => {
                              return (
                                <Radio
                                  label={value1.title}
                                  value={value1.title}
                                  checked={
                                    value1.is_checked != undefined
                                      ? value1.is_checked
                                      : false
                                  }
                                  name={value1.question_id}
                                  onChange={(e) =>
                                    this.props.Update_estimator_QuestionAnswer(
                                      e,
                                      key,
                                      key1,
                                      value1.id,
                                      value1.question_id,
                                      value.id
                                    )
                                  }
                                />
                              );
                            }
                          )}
                        </div>
                      </div>
                    );
                  } else {
                    return null;
                  }
                }
              }
            )
          : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state.reducer;
};

export default connect(mapStateToProps, actionCreator)(Questions);
